export function sortIntervals(intervals) {
  return intervals.sort((a, b) => {
    const timeA = a.from.time;
    const timeB = b.from.time;
    return timeA.localeCompare(timeB);
  });
}
